module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-21.a5a3b4b5.svg";